module.exports = __webpack_public_path__ + "static/content-4-mobile-d510659463d88db86b3f36b7543a17cf.png";